import { useState, useEffect, useRef } from "react";
import Modal from "../../components/general/Modal";

import {
  Body,
  ButtonSpace,
  Container,
  Description,
  Footer,
  LeftBody,
  Link,
  NewAttachments,
  RightBody,
  RightFooter,
  RightHeader,
  RightContent,
  SubTitles,
  TaskDateH,
  TaskHeader,
  TaskHeaderLeft,
  TaskNameH,
  TaskStatusH,
  TaskWorker,
  WorkerIcon,
  WorkerID,
  InputDiv,
  LeftScroll,
  TaskDescription,
  LeftContent,
  Options,
  DescriptionText,
  LabelIconsContainer,
  LabelInput,
} from "./styles";

import Subtasks from "./Subtasks";
import MessageRender from "./MessageRender";
import MessageInput from "./MessageRender/MessageInput";

import { useSelector, useDispatch } from "react-redux";
import { useGantt } from "../../hooks/useGantt";
import useScrollToBottom from "../../hooks/useScrollToButton";

import { getCurrentTask } from "../../state/activedTasks/selectors";
import { getEdgeByNodeId } from "../../state/activedFlows/selectors";

import Button from "../../components/general/Button";

import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { ConfirmActivedTaskModal } from "./ConfirmActivedTaskModal";
import ReactLoading from "react-loading";
import { toastAlert } from "../../components/Toastify/index";
import moment from "moment";
import { handleNewMessage } from "../../state/chat/actions";
import {
  handleConfirmTask,
  handleAddSubtask,
  handleUpdateSubtask,
  handleRemoveSubtask,
  handleUpdateDescription,
  handleUpdateTaskLabel,
  handleUpdateDeadline,
} from "../../state/activedFlows/actions";

import Upload from "../UploadFile/index";
import Attachment from "./Attachments/index";

import { useFileAPI } from "../../hooks/useFileAPI";
import { ProtectedComponent } from "../general/Protected/index";
import Accountable from "../general/Accountable/index";
import {
  Close,
  ArrowRightMTask,
  ConfirmSubtask,
  EditIcon,
  TaskSquare,
  Flag,
} from "./assets";
import { handleListTaskAccountable } from "../../state/users/actions";
import {
  handleUpdateAccountableTask,
  handleRemoveAccountableTask,
} from "../../state/activedFlows/actions";
import { DatePickerWrapper } from "../DatePickerInput";
import { DateTime } from "luxon";

const getProgress = (data, job) => {
  const status = data.status;

  if (!job) {
    return { message: "Fora do Escopo", status: "none" };
  }

  if (status === "done" || status === "doing") {
    const baseTime = moment(data.startedAt)
      .add(data.expiration.number, "hours")
      .format();

    if (status === "done") {
      const finishedAt = moment(data.finishedAt);
      const diff = finishedAt.diff(baseTime, "hours");

      if (diff < 0) {
        return { message: "Concluído", status: "done" };
      } else {
        return { message: "Concluído com atraso", status: "doneLate" };
      }
    } else {
      const nowLocal = moment().utcOffset(-180);
      const diff = nowLocal.diff(baseTime, "hours");
      if (diff < 0) {
        return { message: "Em execução", status: "doing" };
      } else {
        return {
          message: "Atrasado em ~" + Math.round(diff / 24) + " dias",
          status: "late",
        };
      }
    }
  } else {
    return { message: "Pendente", status: "pending" };
  }
};

const ConfirmTaskButton = ({ status, onClose, confirm, setState }) =>
  status === "doing" ? (
    <ButtonSpace>
      <Button
        content={<span style={{ fontSize: "13.5px" }}>Voltar</span>}
        outline
        width={"7.95rem"}
        onClick={onClose}
      />

      <Button
        greenBase
        disabled={confirm}
        content={<span style={{ fontSize: "13.5px" }}>Concluir Tarefa</span>}
        width={"11.75rem"}
        onClick={() => setState(true)}
      />
    </ButtonSpace>
  ) : null;
const DatePickerComponent = ({
  refPicker,
  job,
  task,
  state,
  onClose,
  flow,
}) => {
  const momentDate = DateTime.fromJSDate(job?.end).setLocale("pt-BR");
  const deadline = momentDate.toFormat("dd LLL yy");
  const user = useSelector((state) => state.auth.user);
  const { promiseInProgress: loading } = usePromiseTracker({
    area: "confirm-picker",
  });

  const statusPermission = job?.status === "doing" || job?.status === "late";
  const rankPermission = user.rank === "admin" || user.rank === "gerente";

  const dispatch = useDispatch();

  const { loadGantt } = useGantt();
  const elements = useSelector(
    (state) => state.activedFlows.pane.flow.elements
  );

  async function reloadGantt(task) {
    const upElements = elements.map((item) =>
      item._id === task._id ? (item = task) : item
    );
    loadGantt(upElements, flow._id, flow.flowStatus, flow.createdAt);
  }

  async function handleConfirmDatePicker(task, delayTime, callback) {
    const delayInMillis = delayTime.getTime();

    let opcoesDate = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    let formatedDate = delayTime.toLocaleDateString("pt-BR", opcoesDate);

    trackPromise(
      dispatch(
        handleUpdateDeadline({
          taskId: task._id,
          delayTime: delayInMillis,
        })
      )
        .then(async (res) => {
          toastAlert({
            msg: `A tarefa ${task.data.label} teve o prazo atualizado para ${formatedDate}`,
          });
          await callback(res.payload);
        })
        .catch(() => {
          toastAlert({
            isError: true,
            msg: `Ocorreu um erro ao atualizar a data da tarefa`,
          });
          onClose();
        }),
      "confirm-picker"
    );
  }

  return (
    <>
      {statusPermission && rankPermission ? (
        <DatePickerWrapper
          refPicker={refPicker}
          state={state}
          date={momentDate}
          onConfirm={(data) => handleConfirmDatePicker(task, data, reloadGantt)}
          isLoading={loading}
        >
          <TaskDateH status={job?.status}>
            <Flag />
            {deadline}
          </TaskDateH>
        </DatePickerWrapper>
      ) : (
        <TaskDateH status={job?.status}>
          <Flag />
          {deadline}
        </TaskDateH>
      )}
    </>
  );
};

const getDelayDate = (job) => {
  if (!job) return false;

  if (job.status === "doing") {
    const DayinMillis = 24 * 60 * 60 * 1000;
    const date = new Date(job.end.getTime() + DayinMillis);

    return date;
  } else if (job.status === "late") {
    const date = new Date();
    date.setDate(date.getDate() + 1);

    return date;
  } else {
    return false;
  }
};

const TasksModal = ({ id, isOpen, onClose, flow }) => {
  const [comment, setComment] = useState({ msg: "", isOpen: false });
  const [listAccountables, setListAccountables] = useState([]);
  const { jobs, loadGantt } = useGantt();
  const job = jobs.find((item) => item.id === id);
  const dispatch = useDispatch();
  const task = useSelector((state) => getCurrentTask(state, id));

  const accountable = task.data.accountable;

  const user = useSelector((state) => state.auth.user);
  const currentStatus = getProgress(task.data, job);

  const [delayTask, setDelayTask] = useState(getDelayDate(job));

  const refPicker = useRef();
  const [label, setLabel] = useState({ title: task.data.label, isOpen: false });
  const status = task.data.status;
  const description = task.data.comments;
  const [currentSubtask, setCurrentSubtask] = useState({
    id: "",
    title: "",
    checked: false,
  });

  const [confirmActivedTask, setConfirmActivedTask] = useState(false);

  const { promiseInProgress: subtaskLoading } = usePromiseTracker({
    area: "subtasks",
  });
  const { promiseInProgress: chatLoading } = usePromiseTracker({
    area: "fetching-chat",
  });

  const { promiseInProgress: chatSending } = usePromiseTracker({
    area: "chat",
  });

  const nextEdge = useSelector((state) => getEdgeByNodeId(state, task.id));
  const [taskDescription, setTaskDescription] = useState({
    textarea: description,
    isOpen: false,
  });
  const subtasks = task.data.subtasks;

  const handles = {
    updateAcc: handleUpdateAccountableTask,
    removeAcc: handleRemoveAccountableTask,
  };

  const openDescription = () =>
    setTaskDescription({ ...taskDescription, isOpen: true });

  const closeDescription = () =>
    setTaskDescription({ ...taskDescription, isOpen: false });

  const allSubtasksDone = () =>
    subtasks.find((item) => !item.checked) ? true : false;

  const confirmDisable = () => {
    return task.data.status === "doing" && allSubtasksDone() ? true : false;
  };
  const confirm = confirmDisable();

  const elementRef = useScrollToBottom(chatLoading);

  const scrollToBottom = (e) => {
    const el = e.current;
    el.scrollTop = el.scrollHeight - el.clientHeight;
  };

  const statusText =
    currentStatus.status === "doing"
      ? "Em execução"
      : status === "pending"
      ? "Pendente"
      : status === "done"
      ? "Concluído"
      : "Atrasado";

  async function addSubtask() {
    await trackPromise(
      dispatch(handleAddSubtask({ taskId: task._id })),
      "subtasks"
    );
  }

  async function updateSubtask({ title, checked, id }) {
    const response = await trackPromise(
      dispatch(
        handleUpdateSubtask({
          taskId: task._id,
          id,
          title,
          checked,
        })
      ),
      "subtasks"
    );
    return response;
  }

  async function deleteSubtask({ id }) {
    const response = await trackPromise(
      dispatch(handleRemoveSubtask({ taskId: task._id, id })),
      "subtasks"
    );
    return response;
  }

  async function fetchAccountables() {
    try {
      const res = await dispatch(handleListTaskAccountable());
      setListAccountables(res.data.usersByTenant);
    } catch (err) {
      toastAlert({
        msg: `Ocorreu um erro ao buscar usuários disponiveis: ${err}`,
        isError: true,
      });
    }
  }

  async function updateDescription() {
    const response = await trackPromise(
      dispatch(
        handleUpdateDescription({
          taskId: task._id,
          description: taskDescription.textarea,
        })
      ),
      "description"
    );
    return response;
  }
  const confirmDescription = () => {
    updateDescription().then((res) => {
      closeDescription();
    });
  };

  async function confirmTask() {
    await trackPromise(
      dispatch(
        handleConfirmTask({
          flowId: task.flowId,
          taskId: task._id,
          edge: nextEdge._id,
        })
      ).then((res) => moveToNextTarget(res.payload.flow.elements)),
      "activate-task"
    );
  }

  function moveToNextTarget(newElements) {
    toastAlert({ msg: `TAREFA CONCLUÍDA: ${task.data.label}` });
    loadGantt(newElements, flow._id, flow.flowStatus, flow.createdAt);
    onClose();
  }
  const sanitizeMessage = (msg) => {
    const withoutTags = msg.replace(/<[^>]*>?/gm, "");
    const cleaned = withoutTags.replace(/\n{3,}/g, "\n\n").trim();
    return cleaned;
  };
  const isMessageValid = (msg) => msg.replace(/[\s\n\r]/g, "").length > 0;
  async function newMessage(msg) {
    if (!isMessageValid(msg) || chatSending) {
      return;
    }
    await trackPromise(
      dispatch(
        handleNewMessage({
          userId: user._id,
          ref: { flowId: task.flowId, taskId: task._id },
          username: user.username,
          message: sanitizeMessage(msg),
          type: "task",
        })
      ).then(() => {
        setComment({ ...comment, msg: "" });
        scrollToBottom(elementRef);
      }),
      "chat"
    );
  }

  function handleOpenLabelInput() {
    setLabel({ ...label, isOpen: true });
  }

  function handleUpdateLabel() {
    if (label.title.length > 40) {
      toastAlert({
        msg: "Tamanho máximo de 40 caractéres para RÓTULO de tarefa!!",
        isError: true,
      });
      return;
    }

    if (label.title === "" || label.title === task.data.label) {
      return;
    }
    dispatch(handleUpdateTaskLabel({ label: label.title, taskId: task._id }))
      .then((res) => {
        setLabel({ ...label, isOpen: false });
      })
      .catch((err) => {
        toastAlert({
          isError: true,
          msg: `Ocorreu um erro ao trocar o título da TAREFA: ${err}`,
        });
        setLabel({ ...label, isOpen: false });
      });
  }

  function handleCancelLabel() {
    setLabel({ title: task.data.label, isOpen: false });
  }

  const { handleUpload, handleDelete, files, fetchFiles } = useFileAPI();

  const verifyAccoutable = () => {
    const isColaborator = user.rank === "colaborador";
    const isAccountable = task.data?.accountable?.userId === user?._id;
    if (isColaborator && !isAccountable) return false;

    return true;
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      fetchFiles(task._id);
      fetchAccountables();
    }
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Container>
        <Body>
          <LeftBody>
            <LeftContent>
              <TaskHeader>
                <TaskHeaderLeft>
                  <TaskSquare />
                  {!label.isOpen ? (
                    <TaskNameH onClick={handleOpenLabelInput}>
                      {label.title}
                    </TaskNameH>
                  ) : (
                    <>
                      <LabelInput
                        type="text"
                        maxLength={40}
                        onChange={(e) =>
                          setLabel({ ...label, title: e.target.value })
                        }
                        value={label.title}
                      />
                      <LabelIconsContainer>
                        <ConfirmSubtask
                          height="1.2rem"
                          className="confirm"
                          onClick={handleUpdateLabel}
                        />
                        <Close
                          className="cancel"
                          onClick={handleCancelLabel}
                          height={"0.8rem"}
                        />
                      </LabelIconsContainer>
                    </>
                  )}

                  <TaskStatusH status={currentStatus.status}>
                    {statusText}
                  </TaskStatusH>
                </TaskHeaderLeft>
                <DatePickerComponent
                  refPicker={refPicker}
                  state={[delayTask, setDelayTask]}
                  job={job}
                  task={task}
                  onClose={onClose}
                  flow={flow}
                />
              </TaskHeader>
              <LeftScroll>
                <SubTitles>Descrição</SubTitles>
                <Description description={!!description}>
                  {description && !taskDescription.isOpen ? (
                    <DescriptionText>
                      <p>{description}</p>
                      {status !== "done" ? (
                        <EditIcon onClick={openDescription} />
                      ) : null}
                    </DescriptionText>
                  ) : !description &&
                    !taskDescription.isOpen &&
                    status !== "done" ? (
                    <span onClick={openDescription}>
                      Clique aqui para adicionar uma descrição..
                    </span>
                  ) : taskDescription.isOpen ? (
                    <TaskDescription>
                      <textarea
                        maxLength={200}
                        name="TaskDescriptionArea"
                        type="text"
                        id="CommentsOrAdditionalInformation"
                        value={taskDescription.textarea}
                        onChange={(e) =>
                          setTaskDescription({
                            ...taskDescription,
                            textarea: e.target.value,
                          })
                        }
                      ></textarea>
                      <Options>
                        <ConfirmSubtask
                          className="confirm"
                          onClick={
                            taskDescription.textarea
                              ? () => confirmDescription()
                              : null
                          }
                        />
                        <Close
                          className="cancel"
                          onClick={closeDescription}
                          height={"0.8rem"}
                        />
                      </Options>
                    </TaskDescription>
                  ) : (
                    "Sem descrição"
                  )}
                </Description>

                <ProtectedComponent
                  allowed={["admin", "gerente"]}
                  rank={user.rank}
                  callback={() => task.data.status !== "done"}
                >
                  <Accountable
                    style={{ marginTop: "2rem" }}
                    accountable={accountable}
                    list={listAccountables}
                    id={task._id}
                    handles={handles}
                    status={task.data.status}
                  />
                </ProtectedComponent>

                {(user.rank === "colaborador" || status === "done") &&
                accountable ? (
                  <>
                    <SubTitles>Responsável</SubTitles>
                    <TaskWorker>
                      <WorkerIcon src={accountable.avatarURL} />
                      <WorkerID>{accountable.username}</WorkerID>
                    </TaskWorker>
                  </>
                ) : !accountable && status === "done" ? (
                  <>
                    <SubTitles>Responsável</SubTitles>
                    <div>Nenhum</div>
                  </>
                ) : null}
                <SubTitles>
                  Subtarefas
                  {subtaskLoading ? (
                    <ReactLoading
                      height={10}
                      width={10}
                      type="spin"
                      color="#118052"
                    />
                  ) : null}
                </SubTitles>

                <Subtasks
                  addSubtask={addSubtask}
                  deleteSubtask={deleteSubtask}
                  updateSubtask={updateSubtask}
                  subtasks={subtasks}
                  current={currentSubtask}
                  setCurrent={setCurrentSubtask}
                  status={status}
                />

                <NewAttachments>
                  {status !== "done" ? (
                    <Upload
                      onUpload={handleUpload}
                      id={task._id}
                      tenantId={task.tenantId}
                      type="task"
                    />
                  ) : null}

                  {files.map((item) => (
                    <Attachment
                      key={Math.random()}
                      id={item._id}
                      AnexName={item.name}
                      AnexSize={item.readableSize}
                      DownloadLink={item.url}
                      DeleteAttachment={() =>
                        handleDelete({ fileId: item._id, taskId: task._id })
                      }
                    />
                  ))}
                </NewAttachments>
              </LeftScroll>
            </LeftContent>
          </LeftBody>
          <RightBody>
            <RightHeader>Comentários</RightHeader>
            <RightContent ref={elementRef}>
              <MessageRender task={task} user={user} users={listAccountables} />
            </RightContent>
            <RightFooter>
              {status !== "done" ? (
                <InputDiv>
                  <MessageInput
                    chatRef={elementRef}
                    newMessage={newMessage}
                    users={listAccountables}
                    subtasks={subtasks}
                    value={comment.msg}
                    setValue={(e) => setComment({ ...comment, msg: e })}
                    placeholder="Digite um comentário..."
                  />
                </InputDiv>
              ) : null}
            </RightFooter>
          </RightBody>
        </Body>
        <Footer>
          <Link onClick={onClose}>
            Ver fluxo completo <ArrowRightMTask />
          </Link>
          <ProtectedComponent callback={verifyAccoutable}>
            <ConfirmTaskButton
              status={status}
              onClose={onClose}
              confirm={confirm}
              setState={setConfirmActivedTask}
            />
          </ProtectedComponent>
        </Footer>
      </Container>
      <ConfirmActivedTaskModal
        name={task.data.label}
        onConfirm={confirmTask}
        isOpen={confirmActivedTask}
        onClose={() => setConfirmActivedTask(false)}
      />
    </Modal>
  );
};

export default TasksModal;
